import styles from './spinner.module.css';

interface ISpinnerProps {
    size: string | number;
    borderSize: string | number;
    color?: string;
}

export function Spinner({size, borderSize, color = 'var(--blue)'}: ISpinnerProps) {

    const style: React.CSSProperties = {
        '--spinner-width': typeof size === 'number' ? `${size}px` : size,
        '--spinner-min-width': typeof size === 'number' ? `${size}px` : size,
        '--spinner-height': typeof size === 'number' ? `${size}px` : size,
        '--spinner-border-width': typeof borderSize === 'number' ? `${borderSize}px` : borderSize,
        '--spinner-color': color,
    } as React.CSSProperties;

    return (
        <span
            className={styles.spinner}
            style={style}
        ></span>
    );
}
